export const API_BASE_URL = process.env.REACT_APP_PYTHON_UPLOAD_URL;
export const API_GET_DATA = `${API_BASE_URL}/api_one`;
export const API_GRAPH_DATA = `${API_BASE_URL}/api_graph`;
export const API_FILTER_URL = `${API_BASE_URL}/api_filter`
export const API_AIRLINE_FILTER_URL = `${API_BASE_URL}/api_filter_airline`
export const API_REPORTS_SUMMARY = `${API_BASE_URL}/api_reports_summary`
export const API_ALLAIRPORT = `${API_BASE_URL}/api_allairport`
export const API_START_CRON = `${API_BASE_URL}/api_triggerCron`
export const API_CRON_STATUS = `${API_BASE_URL}/api_cron_status`
export const API_CRON_ENABLED = `${API_BASE_URL}/api_cron_enabled`
export const API_UPDATE_API_KEYS = `${API_BASE_URL}/api_updateAPIKeys`
export const API_LOGIN = `${API_BASE_URL}/api_login`
export const API_LOGOUT = `${API_BASE_URL}/api_logout`
export const API_ADD_AIRPORT = `${API_BASE_URL}/api_add_airport`
export const API_DELETE_AIRPORT = `${API_BASE_URL}/api_delete_airport`
export const API_UPDATE_AIRPORT = `${API_BASE_URL}/api_update_airport`
export const API_DYDIFF = `${API_BASE_URL}/api_dydiff`
export const API_APP_DOWNLOAD = `${API_BASE_URL}/api_appdownload`
export const API_ADD_APP_DOWNLOAD = `${API_BASE_URL}/api_add_appdownload`
export const API_DELETE_APP_DOWNLOAD = `${API_BASE_URL}/api_delete_appdownload`
export const API_UPDATE_APP_DOWNLOAD = `${API_BASE_URL}/api_update_appdownload`
export const API_UNIQUE_AP_AL = `${API_BASE_URL}/api_uniqueAPAL`
export const API_AIRLINES = `${API_BASE_URL}/api_airlines`
export const API_ADD_AIRLINE = `${API_BASE_URL}/api_add_airline`
export const API_DELETE_AIRLINE = `${API_BASE_URL}/api_delete_airline`
export const API_UPDATE_AIRLINE = `${API_BASE_URL}/api_update_airline`
export const API_GET_ALL_USERS = `${API_BASE_URL}/api_getAllUsers`
export const API_CREATE_USER = `${API_BASE_URL}/api_create_user`
export const API_UPDATE_USER = `${API_BASE_URL}/api_update_user`
export const API_DELETE_USER = `${API_BASE_URL}/api_delete_user`
export const API_CHANGE_PASSWORD = `${API_BASE_URL}/api_change_password`
export const API_RESET_PASSWORD = `${API_BASE_URL}/api_reset_password`
export const API_PORTAL_RECORD = `${API_BASE_URL}/api_portal_record`
export const API_USAGE_RECORDS = `${API_BASE_URL}/api_usage_records`
export const API_CREATE_USAGE_RECORD = `${API_BASE_URL}/api_usage_record`
export const API_UPDATE_USAGE_RECORD = (id: number | string) => `${API_BASE_URL}/api_usage_record/${id}`
export const API_DELETE_USAGE_RECORD = (id: number | string) => `${API_BASE_URL}/api_usage_record/${id}`
export const API_DASHBOARD_BACKUP_EXPORT = `${API_BASE_URL}/api_dashboard_backup_export`
export const API_FULL_SYSTEM_BACKUP_EXPORT = `${API_BASE_URL}/api_full_system_backup_export`
export const API_FETCH_AUDIO_FILES = `${API_BASE_URL}/api_fetch_audio_files`
export const API_TRANSLATE = `${API_BASE_URL}/api_translate`
export const API_DASHBOARD_DATA = `${API_BASE_URL}/api_data`
export const API_DASHBOARD_SUMMARY = `${API_BASE_URL}/api_fetch_data`
